module.exports = __webpack_public_path__ + "img/alert-notif.35aa0ed5.svg";